module.exports = __webpack_public_path__ + "static/media/Q5.f03f49cb.jpg";